











































































































import { Component, Watch } from 'vue-property-decorator';
import Vehicle from '@/core/interfaces/Vehicle';
import FormFooter from '@/components/FormFooter.vue';
import FormBase from '@/mixins/FormBase';
import { Action, Getter } from 'vuex-class';
import VehicleType from '@/core/interfaces/VehicleType';
import Barn from '@/core/interfaces/Barn';
import ZetaHubzone from '@/core/interfaces/ZetaHubzone';
import vSelect from 'vue-select';

@Component({
    components: { FormFooter, vSelect },
})
export default class VehicleForm extends FormBase<Vehicle> {
    @Action('saveVehicle')
    saveAction!: (barn: Partial<Vehicle>) => Promise<Vehicle>;

    @Getter('farmOptions')
    farms!: {text: string, value: number}[];

    @Getter('vehicleTypes')
    vehicleTypes!: VehicleType[];

    @Getter('barnsByFarm')
    barnsByFarm!: (id: number) => Barn[];

    @Getter('zetaHubZonesByFarm')
    zetaHubZonesByFarm!: (id: number) => ZetaHubzone[];

    farmId: number | null = null;

    barnId: number | null = null;

    zetaIsGroupLamp = false;

    zetaHubZoneId: number | null = null;

    vehicleTypeId = 0;

    name = '';

    localName = '';

    resetAccessToken = false;

    sim = false;

    mfrId: number | null = null;

    mfrVehicleTypeId = 0;

    zetaVehicleTypeIds: number[] = [];

    zetaCalvingVehicleTypeId = 0;

    btClassic = false;

    mounted(): void {
        this.mfrVehicleTypeId = this.vehicleTypes.find(vt => vt.name === 'mfr')?.id || 0;
        this.zetaVehicleTypeIds = this.vehicleTypes.filter(vt => vt.name.startsWith('zeta')).map(vt => vt.id);
        this.zetaCalvingVehicleTypeId = this.vehicleTypes.find(vt => vt.name === 'zeta_calving')?.id || 0;
    }

    @Watch('initial', { immediate: true })
    setFromInitial(): void {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';
        this.localName = this.initial.local_name || '';
        this.farmId = this.initial.farm_id || null;
        this.barnId = this.initial.barn_id || null;
        this.vehicleTypeId = this.initial.vehicle_type_id || 0;
        this.sim = this.initial.sim || false;
        this.mfrId = this.initial.mfr_id || null;
        this.btClassic = this.initial.bt_classic || false;
        this.zetaHubZoneId = this.initial.zeta_hub_zone_id || null;
        this.zetaIsGroupLamp = this.initial.zeta_grouplamp || false;
    }

    get parseForm(): Partial<Vehicle> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
            local_name: this.localName,
            farm_id: this.farmId || 0,
            barn_id: this.barnId,
            vehicle_type_id: this.vehicleTypeId,
            access_token: this.resetAccessToken ? null : this.initial.access_token,
            sim: Boolean(this.sim),
            mfr_id: this.vehicleTypeId === this.mfrVehicleTypeId ? this.mfrId : null,
            bt_classic: Boolean(this.btClassic),
            zeta_hub_zone_id: this.zetaVehicleTypeIds.includes(this.vehicleTypeId) ? this.zetaHubZoneId : null,
            zeta_grouplamp: this.zetaCalvingVehicleTypeId !== this.vehicleTypeId ? this.zetaIsGroupLamp : false,
        };
    }

    @Watch('farmId')
    resetBarn(): void {
        this.barnId = null;
    }

    get zetaHubZones(): ZetaHubzone[] {
        if (!this.farmId) {
            return [];
        }

        return this.zetaHubZonesByFarm(this.farmId);
    }

    get zetaGrouplampOptions(): { text: string; value: boolean }[] {
        return [
            { text: 'Hub', value: false },
            { text: 'Group lamp', value: true },
        ];
    }
}

